// extracted by mini-css-extract-plugin
export const strokeSchuss = "motion-logo-module--stroke-schuss--2hlHq";
export const strokeS = "motion-logo-module--stroke-s--20IuR";
export const strokeCho = "motion-logo-module--stroke-cho--1zmgH";
export const strokeTter = "motion-logo-module--stroke-tter--3H2xQ";
export const strokeT = "motion-logo-module--stroke-t--3t5kV";
export const isPainted = "motion-logo-module--isPainted--2tLMK";